// Module-level loader state for use by axios interceptors (before React tree exists)
let activeCount = 0;
const listeners = new Set();

export function incrementLoader() {
  activeCount += 1;
  listeners.forEach((fn) => fn(activeCount));
}

export function decrementLoader() {
  activeCount = Math.max(0, activeCount - 1);
  listeners.forEach((fn) => fn(activeCount));
}

export function subscribe(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function getActiveCount() {
  return activeCount;
}
